<template>
  <div>
    <sme-alert level="warning" class="mb-3">
      {{
        employee.properties.paused || employee.properties.pause_scheduled_at
          ? $t('employee.lumpSum.alreadyPausedAlert')
          : $t('employee.lumpSum.schedulePauseAlert', { name: employee.full_name })
      }}
    </sme-alert>
    <div>
      {{ $t('employee.lumpSum.description1') }}
      <br />
      {{ $t('employee.lumpSum.description2') }}
    </div>
    <span class="date-picker-header mt-5 mb-5">
      <app-input
        v-model="lumpSumStartDate"
        type="select"
        name="Final Paycheck before the Summer Break"
        :label="$t('employee.lumpSum.finalPaycheckLabel')"
        class="mb-0"
        :disabled="employee.properties.paused || employee.properties.pause_scheduled_at"
        :options="paycheckOptions"
      />
      <div class="align-middle pt-4">➡</div>
      <app-input
        v-model="lumpSumEndDate"
        type="select"
        name="First Paycheck after the Summer Break"
        :label="$t('employee.lumpSum.firstPaycheckLabel')"
        :disabled="employee.properties.paused || employee.properties.pause_scheduled_at"
        :options="paycheckOptions"
      />
    </span>
    <page-sub-footer>
      <b-button
        type="submit"
        variant="primary"
        @click="submitLumpSumSchedule"
        :disabled="!lumpSumStartDate || !lumpSumEndDate || lumpSumStartDate === lumpSumEndDate || saving || saved"
      >
        <b-spinner v-if="saving" class="mr-2" small />
        {{ saving ? $t('common.submittingButton') : $t('common.submitButton') }}
      </b-button>
    </page-sub-footer>
    <sme-alert v-if="saved" level="good" class="mt-3">
      {{ $t('employee.lumpSum.successAlert', { name: employee.full_name }) }}</sme-alert
    >
  </div>
</template>

<script>
import ApiClient from '@/ApiClient';
import AppInput from '@/components/AppInput.vue';
import SmeAlert from '@/components/atoms/SmeAlert.vue';
import PageSubFooter from '@/components/PageSubFooter.vue';

export default {
  name: 'EmployeeLumpSumPay',
  components: { AppInput, PageSubFooter, SmeAlert },
  props: {
    employee: Object,
    futurePayPeriods: Array,
  },
  data() {
    return {
      saving: false,
      saved: false,
      lumpSumStartDate: undefined,
      lumpSumEndDate: undefined,
      paycheckOptions: this.futurePayPeriods.map(ps => ps.paid_on),
    };
  },
  methods: {
    submitLumpSumSchedule() {
      this.saving = true;
      ApiClient.postLumpSumSchedule(this.employee.employee_id, {
        start_paid_on_date: this.lumpSumStartDate,
        end_paid_on_date: this.lumpSumEndDate,
        pay_schedule_id: this.employee.pay_schedule_id,
      }).then(
        () => {
          this.saving = false;
          this.saved = true;
          window.setTimeout(window.location.reload(), 3000);
        },
        error => {
          this.error = error.message;
          this.loading = false;
        },
      );
    },
  },
};
</script>

<style scoped lang="scss">
.date-picker-header {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  gap: 1rem;
}
</style>
